import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Modal, Spin, Tooltip, Icon, message, notification } from 'antd';
import { ApiConstant, /* CodeConstant, */ PageConstant } from '../../../constants';
import { withRouter } from 'react-router-dom';
import VetsmithCalendly from './VetsmithCalendly';
import UploadResumeModal from '../profile/Modals/uploadResume.modal';
import momentDurationFormatSetup from 'moment-duration-format';
import ProfileActions, { openNotification } from '../profile/Profile.actions';
import { pushLog2DV2LogServer } from '../../../services/logging';
import roundCheck from '../../../assets/img/round-check_circle-24px.svg';
import roundUncheck from '../../../assets/img/round-uncheck_circle-24px.svg';
import moment from 'moment';
import { convertTime } from '../../services/commonAPI';
import {StartMCQModal, StartMCQModalV2} from '../tests/Modals/StartMCQ.modal';
import queryString from 'query-string';
import { takeChallengeAction } from '../../reducers/dv2Actions';
import helpers from '../../helpers';
import TagManager from 'react-gtm-module';
import Welcome from './components/Welcome';
import NoFlow from './components/NoFlow';
import Input from '../shared/input/Input';
import { addNewAccountSettings, markVetsmithStepComplete } from '../../../services/Dashboard';
import { getVetsmithSubscribeFlowID, getVetsmithSubscribeSearchParams } from './VetsmithSubscribe';
import getEnv from '../../../../services/util/getEnv';
import { getUserObject } from '../../util/getUserFullName';
import { saveDeveloperAvailability } from "../../../services/Dashboard"
import { GB_FLAGS, withLDFlagsFromBackend } from '../../services/launchDarkly';
import { redirectMCQToVettingEngine, redirectToVettingEngineV2, redirectVetsmithACCToVettingEngine, redirectTWAToVettingEngine, redirectRLHFToVettingEngine, redirectAiToVettingEngine, redirectToVettingEngine } from '../../../../services/util/redirectToVettingEngine';
import { CalendarIcon, CheckMarkIcon, ClockIcon, CrossIcon, PausedIcon } from '../../components/common/CustomIcon';
import FailedMCQModal from '../tests/Modals/FailedMCQ.modal';
import CodingChallengeWarning from '../../../components/Delights/CodingChallengeWarning/CodingChallengeWarning';
import { TestState } from '../../../legacy_components/UI_V2_Components/tests/constants';
import { isJobPageFeatureEnabled } from '../../services/launchDarkly';
import { JobsPages } from '../../services/launchDarkly';
import uuid from 'uuidv4';
import DrawerActions from '../../../actions/Drawer';

momentDurationFormatSetup(moment);

function withVetsmithService(Component, parentService = false) {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }

  const user = getUserObject();
  /**
   * Vetsmith services
   */
  class VetsmithService extends React.Component {

    state = {
      loading: true,
      loadingItem: false,
      selectedFlowId: null,
      showSelectFlow: false,
      firstload: false,
      source: 'portal',
      uploadResumeFile: [],
      activeItem: null,
      email: null,
      enabled: null,
      event_uri: null,
      flow: null,
      full_name: null,
      orderSteps: [],
      resume: null,
      start_date: null,
      steps: {},
      createPasswordModal: null,
      user_id: null,
      warningAPTModalShow: false,
      aptId: 0,
      showFailedModal: {},
      fileList: [],
      isFileUploadAllowed: false,
      accWarningModalShow: false,
      activeCodingChallengeItem: null,
    };

    componentDidMount() {
      this.loadData();
    }

    componentDidUpdate(prevProps) {
      const {
        drawer: {
          exitVetsmith = false
        } = {}
      } = prevProps.store

      const {
        drawer: {
          exitVetsmith: currentExitVetsmith = false
        } = {}
      } = this.props.store

      if (currentExitVetsmith === true && exitVetsmith === false) {
        this.createPassword(this.props.showNavBar ?  PageConstant.JOB_PAGE : PageConstant.DASHBOARD_DEV)
        this.props.dispatch(DrawerActions.exitVetsmith(false))
      }
    }

    isJobDashboardEnabled() {
      const { LDFlags } = this.props;
      const {
        job_dashboard_v2
      } = LDFlags
      return isJobPageFeatureEnabled(job_dashboard_v2, JobsPages.new_jobs_dashboard); 
    }

    getVetsmithFlowRedirectUrl = () => {
      // Url for this specific flow that we will send in redirect url so that redirection happens to this flow not vetsmith listing
      let veRedirectParam = '';
      if (this.state.fastrack) {
        veRedirectParam = `${PageConstant.FAST_TRACK_PAGE}/${this.state.fastrack.id}`
      } else if (this.props.vetsmithJobId) {
        // This prop is sent when component has been loaded through jobs
        veRedirectParam = `${PageConstant.APPLIED_JOBS_PAGE}/${this.props.vetsmithJobId}/specialized-vetting`;
      } else {
        veRedirectParam = `${PageConstant.VETSMITH_PAGE}?flow_id=${this.state.flow.flow_id}`;
      }

      return encodeURIComponent(veRedirectParam);
    }

/**
 * Asynchronously sends Google Tag Manager (GTM) events for rate and MCQ data if conditions are met.
 * 
 * This function fetches rate and MCQ data from the Vetsmith API and checks whether the expected 
 * rate or MCQ data is available. It then sends appropriate GTM events based on the availability 
 * of this data, ensuring that each event is sent only once.
 * 
 * @async
 * @function sendVetsmithRoleRateMCQGTMData
 * @returns {Promise<void>} No return value.
 * @throws Will log an error to the console if the API request fails.
 */
sendVetsmithRoleRateMCQGTMData = async (flowId) => {
  try {
    const apiUrl = `${ApiConstant.BASE_URL}vetsmith/get-rate-event-data?flowId=${flowId}`;
    const response = await axios.get(apiUrl);

    // Retrieve event flags from localStorage to avoid duplicate event submissions
    const apppleJobRateEventSent = localStorage.getItem('apppleJobRateEventSent');
    const appleJobMcqEventSent = localStorage.getItem('appleJobMcqEventSent');
    const fullStackJobMcqEventSent = localStorage.getItem('fullStackJobMcqEventSent');

    // Check if the API response contains the expected data
    if (response.data && response.data.result) {
      const result = response.data.result;

      // Prepare the dataLayer arguments for Google Tag Manager
      const tagManagerArgs = {
        gtmId: getEnv("REACT_APP_GTM_ID"),
        dataLayer: {
          event: "SubmittedExpectedRate",
          ...result
        }
      };

      // Check if the expected rate is available and the event hasn't been sent yet
      const isRateAvailable = !!result.expected_rate_hourly;
      const isMcqDataAvailable = !!result.mcq_maths_score || !!result.mcq_business_analyst_score || !!result.mcq_fullStack_score;

      // Send rate event if applicable
      if (isRateAvailable && apppleJobRateEventSent !== 'true') {
        TagManager.dataLayer(tagManagerArgs);
        localStorage.setItem('apppleJobRateEventSent', 'true');  // Mark the event as sent
      }

      // Send MCQ event if applicable
      if (isMcqDataAvailable && appleJobMcqEventSent !== 'true' && (
        result.mcq_maths_score || result.mcq_business_analyst_score
      )) {
        tagManagerArgs.dataLayer.event = "FinishMCQ";  // Update the event name for MCQ
        TagManager.dataLayer(tagManagerArgs);
        localStorage.setItem('appleJobMcqEventSent', 'true');  // Mark the event as sent
      }

      if (isMcqDataAvailable && fullStackJobMcqEventSent !== 'true' && result.mcq_fullStack_score) {
          tagManagerArgs.dataLayer.event = "FinishMCQ";  // Update the event name for MCQ
          TagManager.dataLayer(tagManagerArgs);
          localStorage.setItem('fullStackJobMcqEventSent', 'true'); 
      }
    }
  } catch (e) {
    console.error("Something went wrong. Please try again later.");  // Handle any errors
  }
};


    loadData = async (flow_id = null, is_fast_track=false) => {
      const urlParams = new URLSearchParams(window.location.search);
      const vetsmithSubscribeFlowId = await getVetsmithSubscribeFlowID();
      let flowId = flow_id || this.props.flowId || parseInt(localStorage.getItem('vetsmith_selected_flow') || vetsmithSubscribeFlowId || urlParams.get('flow_id') || null);
      const subscribeSeachParams = new URLSearchParams(getVetsmithSubscribeSearchParams());
      let source = subscribeSeachParams.get('source') || urlParams.get('source') || null;
      let templateId = subscribeSeachParams.get('templateId') || urlParams.get('templateId') || null;
      if (!source) {
        if (vetsmithSubscribeFlowId) {
          source = 'vetsmith_subscribe';
        } else if (urlParams.get('flow_id')) {
          source = 'vetting_engine';
        }
      }

      this.setState({ source, templateId });

      if (urlParams.get('flow_id')) {
        // Remove the flow_id param from the url
        window.history.replaceState(null, null, window.location.pathname);
      }
      if (parentService && !flowId) return;
      if (!flowId && this.state.flow && this.state.flow.flow_id) {
        flowId = this.state.flow.flow_id;
      }
      localStorage.removeItem('vetsmith_selected_flow');
      localStorage.removeItem('vetsmith_challenge_id');
      localStorage.removeItem('vetsmith_challenge_active');
      localStorage.removeItem('vetsmith_langs');
      localStorage.removeItem('vetsmith_challenge_inprogress');
      if (flowId) {
        // If flowId is found no need to load all vetsmiths just directly load that single flow and select it
        this.loadAndSelectFlow(flowId, source);
      } else {
        try {
          const apiUrl = `${ApiConstant.BASE_URL}v1/vetsmith/`;
          const result = await axios.get(apiUrl);
          const { success, data: flows } = result.data;
          if (!success) {
            this.setState({ loading: false });
            message.error("Something went wrong. Please try again later.");
            return;
          }

          // If there is just one flow, just select that flow, no need to show listing
          if (flows.length === 1) {
            flowId = flows[0].flow_id;
            await this.sendVetsmithRoleRateMCQGTMData(flowId);
            return this.loadAndSelectFlow(flows[0].flow_id, source);
          }

          // showSelectFlow only set to true when there are any flows so that listing component is not shown when no flows exist
          this.setState({ flows, loading: false, firstload: true, showSelectFlow: flows.length > 0, source });
        } catch (error) {
          this.setState({ loading: false });
          message.error("Something went wrong. Please try again later.");
        }
      }
      if (flowId) await this.sendVetsmithRoleRateMCQGTMData(flowId);
    }

    setShowFailedModal(show = true, item = null, test = null) {
      this.setState({ ...this.state, showFailedModal: { visible: show, item, test } });
    }

    setShowAccWarningModalAndActiveCodingChallengeItem(show = true, item = null) {
      const logBody = {
        sessionId: this.state.sessionId,
        user,
        step: 'ACC',
        action: show ? 'VETSMITH_OPEN_ACC_MODAL' : 'VETSMITH_CLOSE_ACC_MODAL',
        challenge: item,
        flow_id: this.state.flow.flow_id
      };
      pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_ACC_CTA`, {}, logBody);

      if(show) {
        this.setState({ activeCodingChallengeItem: item });
      } else {
        this.setState({ activeCodingChallengeItem: null });
      }
      this.setState({ accWarningModalShow: show });
    }

    startAcc = (item) => {
      const {
        use_vetsmith_challenge_versioning = false,
      } = this.props.LDFlags;

      if (use_vetsmith_challenge_versioning) {
        this.proceedMCQV2(item.id, item);
      } else {
        this.proceedMCQ(item.challenge_id, item);
      }
    }

    editSkills = () => {
      window.location.href = PageConstant.MCQ_LIST
    }

    loadAndSelectFlow = async (flowId, source) => {
      try {
        this.setState({ loading: true });
        const apiUrl = `${ApiConstant.BASE_URL}vetsmith/load-user-data?flowId=${flowId}`;
        const result = await axios.get(apiUrl);
        const { success, flows } = result.data;
        if (!success) {
          this.setState({ loading: false });
          message.error("Something went wrong. Please try again later.");
          return;
        }
        if (!flows || flows.length === 0) {
          // It should load all flows if selected flow is not found
          this.loadData();
          return;
        }
        this.selectFlow(flows[0], source);
      } catch (error) {
        this.setState({ loading: false });
        message.error("Something went wrong. Please try again later.");
      }
    }
    
    selectFlow = (flow, source='portal') => {
      const { LDFlags } = this.props;

      const {
        use_vetsmith_challenge_versioning = false,
        use_vetsmith_mcq_challenge_versioning = false,
      } = LDFlags;

      if (flow.steps && flow.steps.mcq_required && Array.isArray(flow.steps.mcq_required.mcq)) {
        if(use_vetsmith_mcq_challenge_versioning){
          flow.steps.mcq_required.mcq = flow.steps.mcq_required.mcq.map(this.initMCQItemV2);
        } else {
          flow.steps.mcq_required.mcq = flow.steps.mcq_required.mcq.map(this.initMCQItem);
        }
      }
      if (flow.steps && flow.steps.mcq_recommended && Array.isArray(flow.steps.mcq_recommended.mcq)) {
        if(use_vetsmith_mcq_challenge_versioning){
          flow.steps.mcq_recommended.mcq = flow.steps.mcq_recommended.mcq.map(this.initMCQItemV2);
        } else {
          flow.steps.mcq_recommended.mcq = flow.steps.mcq_recommended.mcq.map(this.initMCQItem);
        }
      }
      if (flow.steps && flow.steps.multiple_lang_coding_challenge && Array.isArray(flow.steps.multiple_lang_coding_challenge.acc)) {
        if(use_vetsmith_challenge_versioning){
          flow.steps.multiple_lang_coding_challenge.acc = flow.steps.multiple_lang_coding_challenge.acc.map(this.initMCQItemV2);
        } else {
          flow.steps.multiple_lang_coding_challenge.acc = flow.steps.multiple_lang_coding_challenge.acc.map(this.initMCQItem);
        }
      }
      if (flow.steps && flow.steps.multiple_coding_challenge && Array.isArray(flow.steps.multiple_coding_challenge.acc)) {
        if(use_vetsmith_challenge_versioning){
          flow.steps.multiple_coding_challenge.acc = flow.steps.multiple_coding_challenge.acc.map(this.initMCQItemV2);
        } else {
          flow.steps.multiple_coding_challenge.acc = flow.steps.multiple_coding_challenge.acc.map(this.initMCQItem);
        }
      }

      if (flow.steps && flow.steps.technical_writing_assessment && Array.isArray(flow.steps.technical_writing_assessment.twas)) {
          flow.steps.technical_writing_assessment.twas = flow.steps.technical_writing_assessment.twas.map(this.initMCQItemV2);
      }

      if (flow.steps && flow.steps.rlhf_challenge && Array.isArray(flow.steps.rlhf_challenge.rlhfs)) {
        flow.steps.rlhf_challenge.rlhfs = flow.steps.rlhf_challenge.rlhfs.map(this.initMCQItemV2)
      }

      if (flow.steps && flow.steps.ai_challenge && Array.isArray(flow.steps.ai_challenge.ais)) {
        flow.steps.ai_challenge.ais = flow.steps.ai_challenge.ais.map(this.initMCQItemV2)
      }

      if (flow.steps && flow.steps.nte_challenge && Array.isArray(flow.steps.nte_challenge.ntes)) {
        flow.steps.nte_challenge.ntes = flow.steps.nte_challenge.ntes.map(this.initMCQItemV2)
      }

      if (flow.steps && flow.steps.coding_challenge && flow.steps.coding_challenge.acc) {
        flow.steps.coding_challenge.acc.step_coding_language = flow.steps.coding_challenge.step_coding_language;
        if(use_vetsmith_challenge_versioning){
          flow.steps.coding_challenge.acc = this.initMCQItemV2(flow.steps.coding_challenge.acc);
        } else {
          flow.steps.coding_challenge.acc = this.initMCQItem(flow.steps.coding_challenge.acc);
        }
      }
      if (flow.steps && flow.steps.hyperlink && flow.steps.hyperlink.links) {
        if (flow.workflow_path === 'bar-raiser') {
          flow.steps.hyperlink.links = flow.steps.hyperlink.links.map(link => this.initBarRaiserLink(link, flow.user_id));
        } else {
          flow.steps.hyperlink.links = flow.steps.hyperlink.links.map(this.initLink);
        }
      }
      if(flow.steps && flow.steps.file_upload && flow.steps.file_upload.step_config) {
        flow.steps.file_upload.step_config = flow.steps.file_upload.step_config.map(this.initFileUploadStepConfig);
        flow.steps.file_upload.uploadFiles = this.uploadDeveloperFile;
        flow.steps.file_upload.viewMode = 
            flow.steps.file_upload.files.length === flow.steps.file_upload.step_config.length || flow.steps.file_upload.status === 'Completed';
      }
      if (flow.orderSteps && flow.orderSteps.length) {
        flow.orderSteps.forEach(step => {
          this.initStep(flow.steps[step], use_vetsmith_challenge_versioning);
        });
      }
      const redirectPath = localStorage.getItem("vetsmith_redirect_path");

      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'FLOW_SELECTED',
        { user_id: user.uid },
        { user_id: user.uid, flow_id: flow.flow.flow_id, flow_title: flow.flow.name, redirect_from: redirectPath, action: 'CLICK_VETSMITH_FLOW', page_view: true }, null);
      localStorage.removeItem("vetsmith_redirect_path");
      const sessionId = uuid();
      this.setState({ ...flow, loading: false, firstload: true, showSelectFlow: false, source, sessionId }, () => {
        if (flow.steps && flow.steps.profile) {
          const profileStep = flow.steps.profile;
          const {
            tests: {
              turingProfileCompleted = false
            } = {},
          } = this.props.store;
          if (profileStep.status !== "Completed" && turingProfileCompleted) {
            this.markVetsmithStepCompleteAndRefresh(profileStep.flow_step_id);
          }
        }
      });
    }

    uploadDeveloperFile = async (flow_id, flow_step_id) => {
      this.setState({ loading: true });
      const { fileList } = this.state;
      const formData = new FormData();
      fileList.forEach((file, index) => {
        formData.append(`files[${index}]`, file, file.name);
      });
      formData.append('flow_id',flow_id)
      formData.append('flow_step_id',flow_step_id);
      await axios.post(`${ApiConstant.BASE_URL}${ApiConstant.UPLOAD_DEVELOPER_FILES}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(result => result.data)
        .then( async ({ success }) => {
          if (success) {
            await this.loadData();
            openNotification('success', 'File Upload Success', 'File has been uploaded successfully');
          } else {
            openNotification('error','File Upload Error', 'File upload could not be completed, please try after sometime.');
          }
        })
        .catch(()=>{
          openNotification('error','File Upload Error', 'File upload could not be completed, please try after sometime.');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    initFileUploadStepConfig = (stepConfig) => {
      const { fileList } = this.state;

      stepConfig.uploadFileProps = {
        beforeUpload: (file) => {
          let isFileSizeValid = false;
          let isFileExtensionValid = false;
          let isFileNameValid = false;
          if(file){
            isFileSizeValid = this.checkFileSize(file.size, stepConfig.fileLimit);
            isFileExtensionValid = this.checkFileExtension(file.name, stepConfig.fileExtensions);
            isFileNameValid = this.checkFileName(file.name);
          }
          if(file && isFileSizeValid && isFileExtensionValid && isFileNameValid) {
            // Add the file in the list
            this.setState({
              fileList: [...this.state.fileList, file],
            }, ()=>{
              // Replace the file first if it exists in the file list
              this.setState(state => {
                const index = state.fileList.findIndex((fileInList)=>{
                  return fileInList.uid === stepConfig.fileuid;
                });
                if(index !== -1){
                  const newFileList = state.fileList.slice();
                  newFileList.splice(index, 1);
                  stepConfig.fileName = null;
                  stepConfig.fileuid = null;
                  stepConfig.uploadFileProps.fileList = [];
                  return {
                    fileList: newFileList,
                  };
                }
              }, ()=>{
                // Check whether all the files are selected for the upload button to be enabled
                if(this.state.steps.file_upload.step_config.length === this.state.fileList.length) {
                  this.setState({
                    isFileUploadAllowed: true
                  })
               } else {
                 this.setState({
                   isFileUploadAllowed: false
                 })
               };
               stepConfig.fileName = file.name;
               stepConfig.fileuid = file.uid;
              });
            });
          }
          return false;
        },
        onChange: () => {
          const elementToFocus = document.getElementById('fakeElementToFocus'); // ID of a fake element to refer 
          if (elementToFocus) {
            elementToFocus.focus(); // Set focus to another element to remove focus from file input
          }
        },
        fileList: fileList[fileList.length - 1], 
      };

      stepConfig.onFileRemove = (fileuid) => {
        this.setState(state => {
          const index = state.fileList.findIndex((file)=>{
            return file.uid === fileuid;
          });
          if(index !== -1){
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            stepConfig.fileName = null;
            stepConfig.fileuid = null;
            stepConfig.uploadFileProps.fileList = [];
            return {
              fileList: newFileList,
            };
          }
        }, ()=>{
          if(this.state.steps.file_upload.step_config.length === this.state.fileList.length) {
            this.setState({
              isFileUploadAllowed: true
            })
          } else {
            this.setState({
              isFileUploadAllowed: false
            })
          };
       });
      }
      return stepConfig;
    }

    checkFileSize = (fileSizeInBytes, maximumAllowedFileSize) => {
      const hasGoodSize = fileSizeInBytes < maximumAllowedFileSize;
      if (!hasGoodSize) {
        openNotification(
          'error',
          'File Upload Size Exceeded',
          `File size too big. Please upload a file of less than ${maximumAllowedFileSize/1024/1024}MB in size.`,
          20
        );
        return false;
      }
      return true;
    }

    checkFileExtension = (fileName, allowedExtensions) => {
      let extension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
      if (allowedExtensions.includes(extension)) {
        return true;
      }
      openNotification(
        'error',
        'File Upload Extension Mismatch',
        `File extension does not match the allowed extensions. Please upload a file of ${allowedExtensions.join(', ')} extension.`,
        20
      );
      return false;
    }

    checkFileName = (fileName) => {
      const isFileNameValid = fileName.length <= 250;

      if (!isFileNameValid) {
        openNotification(
          'error',
          'File Name issue',
          `File name is too long! Please rename your file to match under 250 characters!`,
          20
        );
        return false;
      }

      return true;
    }

    initLink = (link) => {
      link.onClick = () => {
        this.setState({ loading: true });
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_HYPERLINK',
          { user_id: user.uid },
          { user_id: user.uid, flow_id: link.flow_id, hyperlink_id: link.hyperlink_id, action: 'CLICK_VETSMITH_HYPERLINK', flow_step_id: link.flow_step_id }, null);
        axios.post(`${ApiConstant.BASE_URL}vetsmith/visit-hyperlink`, { hyperlink_id: link.hyperlink_id, flow_id: link.flow_id, flow_step_id: link.flow_step_id })
          .then(result => result.data)
          .then(({ success }) => {
            if (success) {
              pushLog2DV2LogServer.info(
                'VETSMITH FRONTEND',
                'VETSMITH_HYPERLINK',
                { user_id: user.uid },
                { user_id: user.uid, flow_id: link.flow_id, hyperlink_id: link.hyperlink_id, action: 'VISIT_VETSMITH_HYPERLINK_SUCCESS', flow_step_id: link.flow_step_id }, null);
              link.visited = true;
              this.loadData();
            }
            window.open(link.hyperlink_url, '_blank');
          })
          .catch(console.error)
          .finally(() => {
            this.setState({ loading: false });
          });
      };
      return link;
    }

    initBarRaiserLink = (link, devId) => {
      link.onClick = async () => {
        this.setState({ loading: true });
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_HYPERLINK',
          { user_id: user.uid },
          { user_id: user.uid, flow_id: link.flow_id, hyperlink_id: link.hyperlink_id, action: 'CLICK_VETSMITH_HYPERLINK', flow_step_id: link.flow_step_id }, null);
        const uuid = await axios.get(`${ApiConstant.BASE_URL}fast-track-developers/bar-raiser-uuid/${link.flow_id}`)
          .then(result => result.data)
          .then(({ success, uuid }) => {
            if (success) {
              pushLog2DV2LogServer.info(
                'VETSMITH FRONTEND',
                'VETSMITH_HYPERLINK',
                { user_id: user.uid },
                { user_id: user.uid, flow_id: link.flow_id, hyperlink_id: link.hyperlink_id, action: 'VISIT_VETSMITH_HYPERLINK_SUCCESS', flow_step_id: link.flow_step_id }, null);
              link.visited = true;
              return uuid;
            }
          })
          .catch(console.error)
          .finally(() => {
            this.setState({ loading: false });
          });
        
        if (uuid) {
          axios.post(`${ApiConstant.BASE_URL}vetsmith/visit-hyperlink`, { hyperlink_id: link.hyperlink_id, flow_id: link.flow_id, flow_step_id: link.flow_step_id })
          .then(result => result.data)
          .then(({ success }) => {
            if (success) {
              pushLog2DV2LogServer.info(
                'VETSMITH FRONTEND',
                'VETSMITH_HYPERLINK',
                { user_id: user.uid },
                { user_id: user.uid, flow_id: link.flow_id, hyperlink_id: link.hyperlink_id, action: 'VISIT_VETSMITH_HYPERLINK_SUCCESS', flow_step_id: link.flow_step_id }, null);
              link.visited = true;
              this.loadData();
            }
            window.open(link.hyperlink_url + '/' + uuid, '_blank');
            location.reload();
          })
          .catch(console.error)
          .finally(() => {
            this.setState({ loading: false });
          });
        }
      };
      return link;
    }

    onScheduled = (event_uri) => {
      const { flow_id } = this.state.flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_EVENT',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, event_uri, action: 'CLICK_VETSMITH_EVENT_SCHEDULE' }, null);
      this.setState({ loading: true });
      axios.post(`${ApiConstant.BASE_URL}vetsmith/set-vetsmith-event`, { flow_id, event_uri })
        .then(result => result.data)
        .then(({ success }) => {
          if (success) {
            pushLog2DV2LogServer.info(
              'VETSMITH FRONTEND',
              'VETSMITH_EVENT',
              { user_id: user.uid },
              { user_id: user.uid, flow_id, event_uri, action: 'SET_VETSMITH_EVENT_SCHEDULE_SUCCESS' }, null);
            this.loadData();
          }
        })
        .catch(console.error)
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    Schedule = () => {
      const { full_name, email, event_uri } = this.state;
      return (
        <VetsmithCalendly name={full_name} email={email} event={event_uri} onScheduled={this.onScheduled} />
      );
    }

    setModalProps = (modalName, args, callback) => {
      return this.setState(
        {
          [modalName]: {
            ...this.state[modalName],
            ...args
          }
        },
        callback
      );
    };

    toggleModalVisibility = (modalName) => {
      const modelProps = this.state[modalName];
      const visible = modelProps ? !modelProps.visible : true;
      const { flow_id } = this.state.flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_MODAL_VISIBILITY',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, modalName, visible, action: 'CLICK_VETSMITH_MODAL_ACTION' }, null);
      if (visible) {
        this.setModalProps(modalName, { visible, key: new Date() });
      } else {
        this.setModalProps(modalName, { visible });
      }
    };

    handleUploadResumeClick = (e) => {
      const { flow_id } = this.state.flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_RESUME_UPLOAD',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, action: 'CLICK_RESUME_UPLOAD_BUTTON' }, null);

      const modalName = 'uploadResumeProps';
      const modalProps = this.state[modalName];
      
      const logBody = {
        sessionId: this.state.sessionId,
        user,
        flow_id,
        step: 'resume',
        action: modalProps && modalProps.visible ? 'CLOSE_UPLOAD_RESUME_MODAL' : 'OPEN_UPLOAD_RESUME_MODAL'
      }
      pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_RESUME_CTA`, {}, logBody);
      this.toggleModalVisibility(modalName)
    };

    updateAvailabilityAndMarkStepCompleted = async (stepId, availability = null) => {
      this.setState({
        loadingItem: true
      });
      await this.updateAvailability(availability);
      await this.markVetsmithStepCompleteAndRefresh(stepId);
      this.setState({
        loadingItem: false
      })
    }

    updateAvailability = async (availability = null) => {
      const data = availability || {
        answer: "ready-to-interview",
        availabilityStatusId: 3,
        startsInWeeks: 0
      };
      await saveDeveloperAvailability(data);
    }

    markVetsmithStepCompleteAndRefresh = async (stepId) => {
      const { flow } = this.state;
      await markVetsmithStepComplete(flow.flow_id, stepId);
      await this.loadData(flow.flow_id);
    }

    redirectWithFastrackParam = (url) => {
      if(this.state.fastrack) {
        this.props.history.push(`${url}?redirectBackToFastrack=${this.state.fastrack.id}`);
      }
    }

    visitProfilePageToUpdateProfile = () => {
      this.redirectWithFastrackParam(PageConstant.FINALIZE_RESUME);
    }

    visitProfilePageToUpdateRequiredChanges = () => {
      const { flow_id } = this.state.flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_RESUME_UPLOAD',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, action: 'CLICK_UPDATE_PROFILE_BUTTON' }, null);
      localStorage.setItem('vetsmith_referred_for_profile_update', JSON.stringify({
        flow_id,
      }));
      this.goto(PageConstant.FINALIZE_RESUME);
    }

    saveUploadResume = (e) => {
      const { uploadResumeFile = [], flow } = this.state;
      const { flow_id } = flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_RESUME_UPLOAD',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, action: 'VETSMITH_UPLOADING_RESUME' }, null);
      if (uploadResumeFile && uploadResumeFile.length) {
        this.setModalProps('uploadResumeProps', { confirmLoading: true });
        this.props.dispatch(ProfileActions.SAVE_RESUME(uploadResumeFile[0], () => {
          this.setState({ uploadResumeFile: [] });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_RESUME_UPLOAD',
            { user_id: user.uid },
            { user_id: user.uid, flow_id, action: 'VETSMITH_UPLOADING_RESUME_SUCCESS' }, null);

          const logBody = {
            sessionId: this.state.sessionId,
            user,
            flow_id,
            step: 'resume',
            action: 'RESUME_UPLOAD'
          }
          pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_RESUME_CTA`, {}, logBody);

          this.loadData();
          this.setModalProps('uploadResumeProps', {
            confirmLoading: false,
            visible: false
          });
        }));
      } else {
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_RESUME_UPLOAD',
          { user_id: user.uid },
          { user_id: user.uid, flow_id, action: 'VETSMITH_UPLOAD_RESUME_CANCEL' }, null);
        this.setModalProps('uploadResumeProps', {
          confirmLoading: false,
          visible: false
        });
      }
    };

    goto = (page) => {
      localStorage.removeItem('vetsmith_token');
      if (typeof page === 'function') {
        try {
          page();
        } catch (err) {
          console.log(err);
        }
        return;
      }
      if (`${page}`.trim().startsWith('http')) {
        window.location = page;
      } else {
        this.props.history.push(page);
      }
    }

    optOut = () => {
      const { flow_id } = this.state.flow;
      pushLog2DV2LogServer.info(
        'VETSMITH FRONTEND',
        'VETSMITH_OPT_OUT',
        { user_id: user.uid },
        { user_id: user.uid, flow_id, action: 'VETSMITH_OPT_OUT_CLICKED' }, null);
      Modal.confirm({
        className: 'Vetsmith-modal-opt-out',
        icon: <Icon type="exclamation-circle" theme="outlined" />,
        title: 'Opt out of this job opportunity',
        content: 'Please, be sure you want to opt out of this job opportunity, you won’t be able to re-enter this selection process again.',
        okText: 'Yes, opt out',
        onOk: () => {
          this.createPassword(() => {
            axios.post(`${ApiConstant.BASE_URL}vetsmith/opt-out/`, { flow_id: this.state.flow.flow_id })
              .catch(console.error)
              .finally(() => {
                this.goto(PageConstant.DASHBOARD_DEV);
                pushLog2DV2LogServer.info(
                  'VETSMITH FRONTEND',
                  'VETSMITH_OPT_OUT',
                  { user_id: user.uid },
                  { user_id: user.uid, flow_id, action: 'VETSMITH_OPT_OUT_CONFIRMED' }, null);
              });
          });
        }
      });
    }

    initStep = (step, use_vetsmith_challenge_versioning = false) => {
      const Completed = (txt) => (
        <span className="Vetsmith-Completed">
          <img
            src={roundCheck}
            style={{
              width: 18,
              height: 18,
              background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
              opacity: 1
            }}
            alt="check"
          />
          <span>{txt}</span>
        </span>
      );
      const DidDidntPass = (
        <span className="Vetsmith-DidDidntPass">
          <img
            src={roundUncheck}
            style={{
              width: 18,
              height: 18,
              background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
              opacity: 1
            }}
            alt="check"
          />
          <span>Didn&apos;t pass</span>
        </span>
      );
      const Expired = (
        <span className="Vetsmith-DidDidntPass">
          <img
            src={roundUncheck}
            style={{
              width: 18,
              height: 18,
              background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
              opacity: 1
            }}
            alt="check"
          />
          <span>Expired</span>
        </span>
      );
      step.Status = (args) => {
        switch (step.step) {
          case 'resume':
            if (step.status === 'Completed') {
              return (
                <span className="Vetsmith-status">
                  {Completed('Completed')}
                  <Button type='primary' style={{ width: 55, minWidth: 55 }} onClick={this.handleUploadResumeClick} ><span className="material-icons">file_upload</span></Button>
                </span>
              );
            } else {
              return <span className="Vetsmith-status"><Button type='primary' onClick={this.handleUploadResumeClick} ><span className="material-icons">file_upload</span> <span>Upload Resume</span></Button></span>;
            }
          case 'coding_challenge':
            if(use_vetsmith_challenge_versioning){
              if (step.status === 'Completed' || step.status === 'Passed') {
                return <span className="Vetsmith-status">{Completed('Completed')}</span>;
              } else if (step.acc && step.acc.state === TestState.COMPLETED && !step.acc.passed) {
                return <span className="Vetsmith-status">{DidDidntPass}</span>;
              } else if (step.acc && step.acc.state === TestState.IN_PROGRESS) {
                return <span className="Vetsmith-status"><Button type='primary' disabled={step.disabled} onClick={step.acc.proceed} ><span className="material-icons">code</span> <span>Continue</span></Button></span>;
              } else if (step.acc && step.acc.state === TestState.TODO) {
                return <span className="Vetsmith-status"><Button type='primary' disabled={step.disabled} onClick={step.acc.proceed} ><span className="material-icons">code</span> <span>Start Challenge</span></Button></span>;
              } else {
                return null;
              }
            } else {
              if (step.status === 'Completed' || step.status === 'Passed') {
                return <span className="Vetsmith-status">{Completed('Completed')}</span>;
              } else if (step.acc && !step.acc.timeLeft && (step.acc.passed === 0 || step.acc.passed === 2) && step.acc.submit_time) {
                return <span className="Vetsmith-status">{DidDidntPass}</span>;
              } else if (step.acc && step.acc.timeLeft && step.acc.expired) {
                return <span className="Vetsmith-status">{Expired}</span>;
              } else if (step.acc && step.acc.timeLeft) {
                return <span className="Vetsmith-status"><Button type='primary' disabled={step.disabled} onClick={step.acc.proceed} ><span className="material-icons">code</span> <span>Continue</span></Button></span>;
              } else if (step.acc) {
                return <span className="Vetsmith-status"><Button type='primary' disabled={step.disabled} onClick={step.acc.proceed} ><span className="material-icons">code</span> <span>Start Challenge</span></Button></span>;
              } else {
                return null;
              }
            }
          case 'calendly':
            if (step.status === 'Completed') {
              return <span className="Vetsmith-status">{Completed('Scheduled')}</span>;
            } else {
              const { full_name, email, status, event_uri } = this.state;
              return <span className="Vetsmith-status"><VetsmithCalendly name={full_name} email={email} status={status} event={event_uri} eventLink={step.step_external_url} onScheduled={this.onScheduled} /></span>;
            }
          case 'customer_status_update':
            if (this.state.flow && this.state.flow.job_id) {
              return <span className="Vetsmith-status">{this.getJobStatus(step.job_match_status) || ''}</span>;
            }
            return null;
          case 'custom_profile_questions':
            if (step.status === 'Completed') {
              return (
                <span className="Vetsmith-status">
                  {Completed('Completed')}
                </span>
              );
            } else {
              return <span className="Vetsmith-status"><Button className="profile-update-btn" type="default" onClick={this.visitProfilePageToUpdateRequiredChanges} ><span className="material-icons">file_upload</span> <span>Update Profile</span></Button></span>;
            }

          case 'availability':
            if (step.status === 'Completed') {
              return (
                <span className="Vetsmith-status">
                  {Completed('Completed')}
                </span>
              );
            } else {
              return <Button
                loading={this.state.loadingItem}
                type="primary"
                onClick={() => this.updateAvailabilityAndMarkStepCompleted(step.flow_step_id)} >
                Mark me as available
              </Button>;
            }
            case 'profile':
              const { turingProfileCompleted = false } = this.props.store.tests || {};
              if (step.status === 'Completed' || turingProfileCompleted) {
                return (
                  <span className="Vetsmith-status">
                    {Completed('Completed')}
                  </span>
                );
              } else {
                return <Button
                  loading={this.state.loadingItem}
                  type="primary"
                  onClick={this.visitProfilePageToUpdateProfile} >
                  Update Profile
                </Button>;
              }
          default:
            return null;
        }
      };
      return step;
    };

    startMultipleACCVE = (challengeId, lang) => {
      const veRedirectParam = this.getVetsmithFlowRedirectUrl();
      const redirectLink = window.location.origin + veRedirectParam;
      redirectVetsmithACCToVettingEngine(challengeId, lang, redirectLink)
    }

    /**
     * This function will not be used for acc challenges when `use_vetsmith_challenge_versioning` flag is ON.
     * This function will not be used for mcq challenges when `use_vetsmith_mcq_challenge_versioning` flag is ON. 
     */
    initMCQItem = (item) => {
      item.start = () => {
        const { history, LDFlags } = this.props;

        const {
          maintenance_mcq_acc_apt = false,
          vetsmith_flow_ids_hide_acc_proctoring_modal = []
        } = LDFlags;

        const { flow_id } = this.state;
        const hideProctorModal = vetsmith_flow_ids_hide_acc_proctoring_modal.indexOf(flow_id) >= 0;

        if (maintenance_mcq_acc_apt) {
          openNotification(
            'info',
            'Maintenance',
            'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
            20
          );
          return;
        }

        if (item.is_multiple_acc) {
          this.startMultipleACCVE(item.challenge_id, item.step_coding_language)
          return;
        }

        if(item.is_multiple_coding_challenge){
          if (hideProctorModal) {
            this.startAcc(item);
          } else {
            this.setShowAccWarningModalAndActiveCodingChallengeItem(true, item);
          }
          return;
        }

        if (+item.acc_challenge !== 1) {
          this.setState({ activeItem: item });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            { user_id: user.uid, flow_id: this.state.flow.flow_id, mcq: item, action: 'VETSMITH_CLICK_START_MCQ' }, null);
          pushLog2DV2LogServer.info('TESTS', 'CLICK_TO_START_MCQ', {}, { mcq: item }, null);

          if (item.is_twa) {
            const logBody = {
              sessionId: this.state.sessionId,
              user,
              step: 'TWA',
              action: 'VETSMITH_OPEN_TWA_MODAL',
              challenge: item,
              flow_id: this.state.flow.flow_id
            };
            pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
          } else {
            const logBody = {
              sessionId: this.state.sessionId,
              user,
              step: 'MCQ',
              action: 'VETSMITH_OPEN_MCQ_MODAL',
              challenge: item,
              flow_id: this.state.flow.flow_id
            };
            pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
          }
        }
      };
      item.close = () => {
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          `VETSMITH_CLOSE_${+item.acc_challenge === 1 ? 'ACC' : 'MCQ'}`,
          { user_id: user.uid },
          { user_id: user.uid, flow_id: this.state.flow.flow_id, mcq: item, action: `VETSMITH_CANCEL_${+item.acc_challenge === 1 ? 'ACC' : 'MCQ'}_BUTTON_CLICKED` }, null);

        if (item.is_twa) {
          const logBody = {
            sessionId: this.state.sessionId,
            user,
            step: 'TWA',
            action: 'VETSMITH_CLOSE_TWA_MODAL',
            challenge: item,
            flow_id: this.state.flow.flow_id
          };
          pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
        } else {
          const logBody = {
            sessionId: this.state.sessionId,
            user,
            step: 'MCQ',
            action: 'VETSMITH_CLOSE_MCQ_MODAL',
            challenge: item,
            flow_id: this.state.flow.flow_id
          };
          pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
        }

        this.setState({ activeItem: null });
      };
      // Please make a note that `allMCQSkillsInProjectExperience` has been removed from the new MCQ List API /api/v1/challenge/mcq/
      item.certified = !!(item.submit_time && item.passed === 1 && item.allMCQSkillsInProjectExperience);
      item.isCompleted = false;
      item.CompletedOrTime = null;
      if (item.timeLeft > 0) { // it shows "paused" label when user submits before the timeer expires, regardless of the result
        item.CompletedOrTime = args => (
          <span className="time-left">
            {`${moment
              .duration(item.timeLeft, 'seconds')
              .format('m [min]')} left`}
          </span>
        );
        if (item.is_multiple_acc || item.is_multiple_coding_challenge) {
          item.MCQStatusOrTime = args => (
            <span className='turing-ui-v2-mcq-tests-item-time-left-wrap'>
              <span className='turing-ui-v2-mcq-tests-item-time-paused'>
                <PausedIcon />
                Paused
              </span>
              <Tooltip title={<span className='tooltip-message'> {`${moment
                .duration(item.timeLeft, 'seconds')
                .format('m')} min left`}</span>}>
                <span className="turing-ui-v2-mcq-tests-item-time-left">
                  <ClockIcon />
                  {`${moment
                    .duration(item.timeLeft, 'seconds')
                    .format('m')} m`}
                </span>
              </Tooltip>
            </span>
          );
        } else {
          item.MCQStatusOrTime = args => (
            <span className="turing-ui-v2-mcq-tests-item-time-left">
              {`${moment
                .duration(item.timeLeft, 'seconds')
                .format('m [min]')} left`}
            </span>
          );
        }
      } else if (item.passed === 3 && item.timeLeft === 0 && item.submit_time) { // when the test timer has expired, but user didn't submit the solution. Its not possible
        // in case of "ACC":
        // if solution_submitted is false and time_left is zero, it means that user has submitted the solution
        // but the result is not yet ready, in that case we have to show "Grading Solution" with no action button
        if (item.is_multiple_acc || item.is_multiple_coding_challenge) {
          item.MCQStatusOrTime = args => (
            <Tooltip
              placement="top"
              title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
            >
              <span className="turing-ui-v2-mcq-tests-item-time-paused">
                <span>
                  Grading Results
                </span>
              </span>
              <span style={{ fontSize: '10px', color: '#565c61' }}>Please check back in 5-10 minutes for final results</span>
            </Tooltip>
          );
        } else {
          item.MCQStatusOrTime = args => (
            <Tooltip
              placement="top"
              title={moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
            >
              <span className="completed">
                <img
                  src={roundCheck}
                  style={{
                    width: 18,
                    height: 18,
                    background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
                    opacity: 1
                  }}
                  alt="check"
                />
                <span
                  style={{
                    marginLeft: 10,
                    textAlign: 'right'
                  }}
                >
                  Completed
                </span>
              </span>
            </Tooltip>
          );
        }
      } else if (item.submit_time) { // when test has been submitted
        const result = item.passed === 1 ? 'Passed' : ((item.passed === 2 || item.passed === 0) ? 'Didn\'t pass' : '');
        item.isCompleted = true;
        const ninetyDays = moment(item.submit_time).add(3, 'months');
        const daysDiff = moment(ninetyDays).diff(moment(), 'days');
        const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
        let timeText = '';
        let timeTip = '';
        let retake = false;
        if (item.passed === 2 || item.passed === 0) { // checking if user has failed it
          if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
            timeText = `${hoursDiff} hr`;
            timeTip = `You will be able to take this test again in ${hoursDiff}${hoursDiff > 1 ? ' hrs' : ' hr'}.`;
          } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
            timeText = '< 1 hr';
            timeTip = 'You will be able to retake this test again soon.';
          } else if (daysDiff >= 1) {
            timeText = `${daysDiff} d`;
            timeTip = `You will be able to take this test again in ${daysDiff}${daysDiff > 1 ? ' days' : ' day'}.`;
          } else if (daysDiff < 0) {
            retake = true;
          }
        }
        if (item.is_multiple_acc || item.is_multiple_coding_challenge) {
          item.MCQStatusOrTime = args => (
            <>
              {item.passed === 1
                ? (
                  <Tooltip
                    placement="top"
                    title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                  >
                    <span className="completed">
                      <CheckMarkIcon />
                      <span>
                        {result}
                      </span>
                    </span>
                  </Tooltip>
                )
                : (
                  (item.passed === 2 || item.passed === 0)
                    ? !retake ? (
                      <span className='didntpass-wrap'>
                        <Tooltip
                          placement="top"
                          title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                        >
                          <span className="didntpass">
                            <CrossIcon />
                            <span>
                              {result}
                            </span>
                          </span>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title={<span className='tooltip-message'>{timeTip}</span>}
                        >
                          <span className='retake'>
                            <CalendarIcon /> {timeText}
                          </span>
                        </Tooltip>
                      </span>
                    ) :
                      <span className="turing-ui-v2-mcq-tests-item-time-estimate">
                        <ClockIcon className="turing-ui-v2-mcq-tests-item-time-clock" /> {`${convertTime(item.challenge_duration)} ${args.estimated ? 'estimated' : ''}`}
                      </span>
                    : null
                )}
  
            </>
          );
        } else {
          item.MCQStatusOrTime = args => (
            <Tooltip
              placement="top"
              title={moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
            >
              {item.passed === 1
                ? (
                  <span className="completed">
                    <img
                      src={roundCheck}
                      style={{
                        width: 18,
                        height: 18,
                        background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
                        opacity: 1
                      }}
                      alt="check"
                    />
                    <span
                      style={{
                        marginLeft: 10,
                        textAlign: 'right'
                      }}
                    >
                      {result}
                    </span>
                  </span>
                )
                : (
                  (item.passed === 2 || item.passed === 0)
                    ? (
                      <span className="didntpass">
                        <img
                          src={roundUncheck}
                          style={{
                            width: 18,
                            height: 18,
                            background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
                            opacity: 1
                          }}
                          alt="uncheck"
                        />
                        <span
                          style={{
                            marginLeft: 10,
                            textAlign: 'right'
                          }}
                        >
                          {result}
                        </span>
                      </span>
                    )
                    : null
                )}
  
            </Tooltip>
          );
        }
      } else {
        item.MCQStatusOrTime = args => {
          /**
           * Estimated time should not be shown the developers attempting ACCs belonging to multiple_coding_challenge step. This is the special condition to address that 
           * requirement
           */
          if(item.is_multiple_coding_challenge){
            return null;
          } 
          return (
              <span className="turing-ui-v2-mcq-tests-item-time">
                {(item.is_multiple_acc) ? <span><ClockIcon /> Max. Time </span> : ''}{`${convertTime(item.challenge_duration)} ${args.estimated ? 'estimated' : ''}`}
              </span>
          )
        }
      }

      item.Action = args => {
        let action = null;
        const acc_anytime = item.acc_anytime === 1 ? true : false;
        if (item.is_multiple_acc || item.is_multiple_coding_challenge) {
          if (item.submit_time) {
            if (item.passed === 1 || (item.passed === 3 && item.timeLeft === 0 && item.submit_time)) {
              if(!item.is_multiple_coding_challenge){
                action = <div className="turing-ui-v2-completed">Completed</div>;
              }
            }
            if (item.passed === 2) {
              const ninetyDays = moment(item.submit_time).add(3, 'months');
              const daysDiff = moment(ninetyDays).diff(moment(), 'days');
              let retake = daysDiff < 0;
              let retakeMessage = null;
              // let retakeMessage = `What can I do now?`;
              let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}.`;
  
              if (item.isTopMCQ) {
                if (item.isFixedMCQ) {
                  const role_name = this.getData('user_role_name', '');
                  let message = 'This MCQ is required';
                  if (role_name) {
                    message += ` for your ${role_name} role`;
                  }
                  action = <small className="turing-ui-v2-action-small-text">{message}</small>;
                } else {
                  action = <Tooltip
                    placement="bottom"
                    title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                  >
                    <div className="turing-ui-v2-reattempt pointer hidden"
                      onClick={(e) => {
                        this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                      }}>
                      {retakeMessage}
                    </div>
                  </Tooltip>;
                }
              } else if (retake) {
                action = <Button data-cy={item.challenge_name} disabled={!acc_anytime} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Start Quiz</Button>;
              } else {
                action = <Tooltip
                  placement="bottom"
                  title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                >
                  <div className="turing-ui-v2-reattempt turing-ui-v2-reattempt-primary pointer hidden"
                    onClick={(e) => {
                      this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                    }}>
                    {retakeMessage}
                  </div>
                </Tooltip>;
              }
            }
            else if (item.passed !== 1 && item.timeLeft > 0) {
              action = <Button data-cy={item.challenge_name} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Continue Challenge</Button>;
            }
          } else {
            action = <Button data-cy={item.challenge_name} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Start Challenge</Button>;
          }
        } else {
          if (item.submit_time) {
            if (item.passed === 2) {
              const ninetyDays = moment(item.submit_time).add(3, 'months');
              const daysDiff = moment(ninetyDays).diff(moment(), 'days');
              const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
              let retakeMessage = `Retake in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}`;
              let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}.`;
              if (daysDiff < 1 && hoursDiff > 0) {
                retakeMessage = `Retake in ${hoursDiff}${hoursDiff > 1 ? 'hrs' : 'hr'}`;
                retakeToolTipMsg = `You will be able to take this test again in ${hoursDiff}${hoursDiff > 1 ? 'hrs' : 'hr'}.`;
              } else if (hoursDiff <= 0) {
                retakeMessage = 'Retake soon';
                retakeToolTipMsg = 'You will be able to retake this test again soon.';
              };
              if (item.isTopMCQ) {
                if (item.isFixedMCQ) {
                  const role_name = this.getData('user_role_name', '');
                  let message = 'This MCQ is required';
                  if (role_name) {
                    message += ` for your ${role_name} role`;
                  }
                  action = <small className="turing-ui-v2-action-small-text">{message}</small>;
                } else {
                  action = <Tooltip
                    placement="bottom"
                    title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                  >
                    <div className="turing-ui-v2-reattempt">{retakeMessage}</div>
                  </Tooltip>;
                }
              } else {
                action = <Tooltip
                  placement="bottom"
                  title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                >
                  <div className="turing-ui-v2-reattempt hidden">{retakeMessage}</div>
                </Tooltip>;
              }
            } else if (item.timeLeft > 0) {
              action = <Button className="turing-ui-v2-action-item" type="link" onClick={item.start}>Continue</Button>;
            }
          } else {
            action = <Button className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={item.start}>{(item.is_multiple_acc || item.is_multiple_coding_challenge || item.is_rlhf || item.is_ai) ? 'Start Challenge' : 'Start Quiz'}</Button>;
          }
        }
        return action;
      };

      item.proceedClicked = () => {
        if (item.timeLeft > 0) {
          // [LOGGING] CLICKED_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_CONTINUE', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Clicked Continue Test'
          });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONTINUE_TEST'
            }, null);
          return;
        }

        // [LOGGING] CLICKED_PROCEED
        pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_PROCEED', {}, {
          challenge_id: item.challenge_id,
          challenge_name: item.challenge_name,
          step: 0,
          correctAnswer: 0,
          message: 'Clicked Proceed Test'
        });

        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_TEST',
          { user_id: user.uid },
          {
            user_id: user.uid,
            flow_id: this.state.flow.flow_id,
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            action: 'VETSMITH_CLICK_START_TEST'
          }, null);
      };

      item.proceed = (e) => {
        e.preventDefault();

        const {
          maintenance_mcq_acc_apt = false
        } = this.props.LDFlags;

        if (maintenance_mcq_acc_apt) {
          openNotification(
            'info',
            'Maintenance',
            'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
            20
          );
          return;
        }

        if (item.timeLeft > 0) {
          // [LOGGING] CONFIRM_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_CONTINUE', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Continue Test'
          });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONFIRM_CONTINUE_TEST'
            }, null);
        } else {
          // [LOGGING] CONFIRM_PROCEED
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_PROCEED', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Proceed Test'
          });

          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONFIRM_START_TEST'
            }, null);
        }

        this.proceedMCQ(item.challenge_id, item);
      };

      return item;
    };

    /**
     * This function gets called when `use_vetsmith_challenge_versioning` flag is turned ON.
     * This function gets called when `use_vetsmith_mcq_challenge_versioning` flag is turned ON.
     */
    initMCQItemV2 = (item) => {
      item.start = () => {
        const { history, LDFlags } = this.props;

        const {
          maintenance_mcq_acc_apt = false,
          vetsmith_flow_ids_hide_acc_proctoring_modal=[]
        } = LDFlags;

        const { flow_id } = this.state;
        const hideProctorModal = vetsmith_flow_ids_hide_acc_proctoring_modal.indexOf(flow_id) >= 0;
        if (maintenance_mcq_acc_apt) {
          openNotification(
            'info',
            'Maintenance',
            'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
            20
          );
          return;
        }

        if (item.is_multiple_acc) {
          // This is verified
          this.startMultipleACCVE(item.id, item.step_coding_language)
          return;
        }

        if(item.is_multiple_coding_challenge){
          if (hideProctorModal) {
            this.startAcc(item);
          } else {
            this.setShowAccWarningModalAndActiveCodingChallengeItem(true, item);
          }
          return;
        }

        if (+item.acc_challenge !== 1) {
          this.setState({ activeItem: item });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            { user_id: user.uid, flow_id: this.state.flow.flow_id, mcq: item, action: 'VETSMITH_CLICK_START_MCQ' }, null);
          pushLog2DV2LogServer.info('TESTS', 'CLICK_TO_START_MCQ', {}, { mcq: item }, null);

          if (item.is_twa) {
            const logBody = {
              sessionId: this.state.sessionId,
              user,
              step: 'TWA',
              action: 'VETSMITH_OPEN_TWA_MODAL',
              challenge: item,
              flow_id: this.state.flow.flow_id
            };
            pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
          } else {
            const logBody = {
              sessionId: this.state.sessionId,
              user,
              step: 'MCQ',
              action: 'VETSMITH_OPEN_MCQ_MODAL',
              challenge: item,
              flow_id: this.state.flow.flow_id
            };
            pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
          }
        }
      };
      item.close = () => {
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          `VETSMITH_CLOSE_${+item.acc_challenge === 1 ? 'ACC' : 'MCQ'}`,
          { user_id: user.uid },
          { user_id: user.uid, flow_id: this.state.flow.flow_id, mcq: item, action: `VETSMITH_CANCEL_${+item.acc_challenge === 1 ? 'ACC' : 'MCQ'}_BUTTON_CLICKED` }, null);
        
        if (item.is_twa) {
          const logBody = {
            sessionId: this.state.sessionId,
            user,
            step: 'TWA',
            action: 'VETSMITH_CLOSE_TWA_MODAL',
            challenge: item,
            flow_id: this.state.flow.flow_id
          };
          pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
        } else {
          const logBody = {
            sessionId: this.state.sessionId,
            user,
            step: 'MCQ',
            action: 'VETSMITH_CLOSE_MCQ_MODAL',
            challenge: item,
            flow_id: this.state.flow.flow_id
          };
          pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
        }

        this.setState({ activeItem: null });
      };
      // Please make a note that `allMCQSkillsInProjectExperience` has been removed from the new MCQ List API /api/v1/challenge/mcq/
      item.certified = !!(item.state === TestState.COMPLETED && item.passed);
      item.isCompleted = false;
      item.CompletedOrTime = null;
      if (item.state === TestState.IN_PROGRESS) { // it shows "paused" label when user submits before the timeer expires, regardless of the result
        item.CompletedOrTime = args => (
          <span className="time-left">
            {`${moment
              .duration(item.timeleft, 'seconds')
              .format('m [min]')} left`}
          </span>
        );
        if (item.is_multiple_acc || item.is_multiple_coding_challenge || item.is_twa || item.is_rlhf || item.is_ai) {
          item.MCQStatusOrTime = args => (
            <span className='turing-ui-v2-mcq-tests-item-time-left-wrap'>
              <span className='turing-ui-v2-mcq-tests-item-time-paused'>
                <PausedIcon />
                Paused
              </span>
              <Tooltip title={<span className='tooltip-message'> {`${moment
                .duration(item.timeleft, 'seconds')
                .format('m')} min left`}</span>}>
                <span className="turing-ui-v2-mcq-tests-item-time-left">
                  <ClockIcon />
                  {`${moment
                    .duration(item.timeleft, 'seconds')
                    .format('m')} m`}
                </span>
              </Tooltip>
            </span>
          );
        } else {
          item.MCQStatusOrTime = args => (
            <span className="turing-ui-v2-mcq-tests-item-time-left">
              {`${moment
                .duration(item.timeleft, 'seconds')
                .format('m [min]')} left`}
            </span>
          );
        }
      } else if (item.state === TestState.COMPLETED) { // when test has been submitted
        const result = item.is_nte ? 'Completed' : item.passed ? 'Passed' : 'Didn\'t pass';
        item.isCompleted = true;
        const ninetyDays = moment(item.submit_time).add(3, 'months');
        const daysDiff = moment(ninetyDays).diff(moment(), 'days');
        const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
        let timeText = '';
        let timeTip = '';
        let retake = false;
        if (!item.passed && !item.is_nte) { // checking if user has failed it
          if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
            timeText = `${hoursDiff} hr`;
            timeTip = `You will be able to take this test again in ${hoursDiff}${hoursDiff > 1 ? ' hrs' : ' hr'}.`;
          } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
            timeText = '< 1 hr';
            timeTip = 'You will be able to retake this test again soon.';
          } else if (daysDiff >= 1) {
            timeText = `${daysDiff} d`;
            timeTip = `You will be able to take this test again in ${daysDiff}${daysDiff > 1 ? ' days' : ' day'}.`;
          } else if (daysDiff < 0) {
            retake = true;
          }
        }
        if (item.is_multiple_acc || item.is_multiple_coding_challenge || item.is_twa || item.is_rlhf || item.is_ai || item.is_nte) {
          item.MCQStatusOrTime = args => (
            <>
              {item.passed || (item.is_nte && item.state === TestState.COMPLETED)
                ? (
                  <Tooltip
                    placement="top"
                    title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                  >
                    <span className="completed">
                      <CheckMarkIcon />
                      <span>
                        {result}
                      </span>
                    </span>
                  </Tooltip>
                )
                : (
                    !retake ? (
                      <span className='didntpass-wrap'>
                        <Tooltip
                          placement="top"
                          title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                        >
                          <span className="didntpass">
                            <CrossIcon />
                            <span>
                              {result}
                            </span>
                          </span>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title={<span className='tooltip-message'>{timeTip}</span>}
                        >
                          <span className='retake'>
                            <CalendarIcon /> {timeText}
                          </span>
                        </Tooltip>
                      </span>
                    ) :
                      <span className="turing-ui-v2-mcq-tests-item-time-estimate">
                        <ClockIcon className="turing-ui-v2-mcq-tests-item-time-clock" /> {`${convertTime(item.duration)} ${args.estimated ? 'estimated' : ''}`}
                      </span>
                )}
            </>
          );
        } else {
          item.MCQStatusOrTime = args => (
            <Tooltip
              placement="top"
              title={moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
            >
              {item.passed
                ? (
                  <span className="completed">
                    <img
                      src={roundCheck}
                      style={{
                        width: 18,
                        height: 18,
                        background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
                        opacity: 1
                      }}
                      alt="check"
                    />
                    <span
                      style={{
                        marginLeft: 10,
                        textAlign: 'right'
                      }}
                    >
                      {result}
                    </span>
                  </span>
                )
                : (
                      <span className="didntpass">
                        <img
                          src={roundUncheck}
                          style={{
                            width: 18,
                            height: 18,
                            background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
                            opacity: 1
                          }}
                          alt="uncheck"
                        />
                        <span
                          style={{
                            marginLeft: 10,
                            textAlign: 'right'
                          }}
                        >
                          {result}
                        </span>
                      </span>
                )}
  
            </Tooltip>
          );
        }
      } else {
        item.MCQStatusOrTime = args => {
          /**
           * Estimated time should not be shown the developers attempting ACCs belonging to multiple_coding_challenge step. This is the special condition to address that 
           * requirement
           */
          if(item.is_multiple_coding_challenge){
            return null;
          } 
          return (
              <span className="turing-ui-v2-mcq-tests-item-time">
                {(item.is_multiple_acc || item.is_twa || item.is_rlhf || item.is_ai || item.is_nte) ? <span><ClockIcon /> Max. Time </span> : ''}{`${convertTime(item.duration)} ${args.estimated ? 'estimated' : ''}`}
              </span>
          )
        }
      }

      item.Action = args => {
        let action = null;
        if (item.is_multiple_acc || item.is_multiple_coding_challenge) {
          if (item.state !== TestState.TODO) {
            if (item.passed && item.state === TestState.COMPLETED) {
              if(!item.is_multiple_coding_challenge){
                action = <div className="turing-ui-v2-completed">Completed</div>;
              }
            }
            if (!item.passed && item.state === TestState.COMPLETED) {
              const ninetyDays = moment(item.submit_time).add(3, 'months');
              const daysDiff = moment(ninetyDays).diff(moment(), 'days');
              let retake = daysDiff < 0;
              let retakeMessage = null;
              // let retakeMessage = `What can I do now?`;
              let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}.`;
  
              if (item.isTopMCQ) {
                if (item.isFixedMCQ) {
                  const role_name = this.getData('user_role_name', '');
                  let message = 'This MCQ is required';
                  if (role_name) {
                    message += ` for your ${role_name} role`;
                  }
                  action = <small className="turing-ui-v2-action-small-text">{message}</small>;
                } else {
                  action = <Tooltip
                    placement="bottom"
                    title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                  >
                    <div className="turing-ui-v2-reattempt pointer"
                      onClick={(e) => {
                        this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                      }}>
                      {retakeMessage}
                    </div>
                  </Tooltip>;
                }
              } else if (retake) {
                action = <Button data-cy={item.name} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Start Quiz</Button>;
              } else {
                action = <Tooltip
                  placement="bottom"
                  title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                >
                  <div className="turing-ui-v2-reattempt turing-ui-v2-reattempt-primary pointer hidden"
                    onClick={(e) => {
                      this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                    }}>
                    {retakeMessage}
                  </div>
                </Tooltip>;
              }
            }
            else if (item.state === TestState.IN_PROGRESS) {
              action = <Button data-cy={item.name} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Continue Challenge</Button>;
            }
          } else {
            action = <Button data-cy={item.name} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={() => item.start(args)}>Start Challenge</Button>;
          }
        } else {
          if (item.state !== TestState.TODO) {
            if (!item.passed && item.state === TestState.COMPLETED && !item.is_nte) {
              const ninetyDays = moment(item.submit_time).add(3, 'months');
              const daysDiff = moment(ninetyDays).diff(moment(), 'days');
              const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
              let retakeMessage = `Retake in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}`;
              let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}.`;
              if (daysDiff < 1 && hoursDiff > 0) {
                retakeMessage = `Retake in ${hoursDiff}${hoursDiff > 1 ? 'hrs' : 'hr'}`;
                retakeToolTipMsg = `You will be able to take this test again in ${hoursDiff}${hoursDiff > 1 ? 'hrs' : 'hr'}.`;
              } else if (hoursDiff <= 0) {
                retakeMessage = 'Retake soon';
                retakeToolTipMsg = 'You will be able to retake this test again soon.';
              };
              if (item.isTopMCQ) {
                if (item.isFixedMCQ) {
                  const role_name = this.getData('user_role_name', '');
                  let message = 'This MCQ is required';
                  if (role_name) {
                    message += ` for your ${role_name} role`;
                  }
                  action = <small className="turing-ui-v2-action-small-text">{message}</small>;
                } else {
                  action = <Tooltip
                    placement="bottom"
                    title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                  >
                    <div className="turing-ui-v2-reattempt">{retakeMessage}</div>
                  </Tooltip>;
                }
              } else {
                action = <Tooltip
                  placement="bottom"
                  title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                >
                  <div className="turing-ui-v2-reattempt">{retakeMessage}</div>
                </Tooltip>;
              }
            } else if (item.state === TestState.IN_PROGRESS) {
              action = <Button className="turing-ui-v2-action-item" type="link" onClick={item.start}>Continue</Button>;
            }
          } else {
            action = <Button className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={item.start}>{(item.is_multiple_acc || item.is_multiple_coding_challenge || item.is_rlhf || item.is_ai || item.is_nte) ? 'Start Challenge' : 'Start Quiz'}</Button>;
          }
        }
        return action;
      };

      item.proceedClicked = () => {
        if (item.state === TestState.IN_PROGRESS) {
          // [LOGGING] CLICKED_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_CONTINUE', {}, {
            challenge_id: item.id,
            challenge_name: item.name,
            step: 0,
            correctAnswer: 0,
            message: 'Clicked Continue Test'
          });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.id,
              challenge_name: item.name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONTINUE_TEST'
            }, null);
          return;
        }

        // [LOGGING] CLICKED_PROCEED
        pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_PROCEED', {}, {
          challenge_id: item.id,
          challenge_name: item.name,
          step: 0,
          correctAnswer: 0,
          message: 'Clicked Proceed Test'
        });

        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_TEST',
          { user_id: user.uid },
          {
            user_id: user.uid,
            flow_id: this.state.flow.flow_id,
            challenge_id: item.id,
            challenge_name: item.name,
            step: 0,
            correctAnswer: 0,
            action: 'VETSMITH_CLICK_START_TEST'
          }, null);
      };

      item.proceed = (e) => {
        e.preventDefault();

        const {
          maintenance_mcq_acc_apt = false
        } = this.props.LDFlags;

        if (maintenance_mcq_acc_apt) {
          openNotification(
            'info',
            'Maintenance',
            'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
            20
          );
          return;
        }

        if (item.state === TestState.IN_PROGRESS) {
          // [LOGGING] CONFIRM_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_CONTINUE', {}, {
            challenge_id: item.id,
            challenge_name: item.name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Continue Test'
          });
          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.id,
              challenge_name: item.name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONFIRM_CONTINUE_TEST'
            }, null);
        } else {
          // [LOGGING] CONFIRM_PROCEED
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_PROCEED', {}, {
            challenge_id: item.id,
            challenge_name: item.name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Proceed Test'
          });

          pushLog2DV2LogServer.info(
            'VETSMITH FRONTEND',
            'VETSMITH_TEST',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              challenge_id: item.id,
              challenge_name: item.name,
              step: 0,
              correctAnswer: 0,
              action: 'VETSMITH_CLICK_CONFIRM_START_TEST'
            }, null);
        }

        this.proceedMCQV2(item.id, item);
      };

      return item;
    };

    proceedMCQ = (challenge_id, item = null) => {
      const {
        maintenance_mcq_acc_apt = false,
        use_vetting_engine_redirection,
        vetsmith_flow_ids_hide_acc_proctoring_modal=[]
      } = this.props.LDFlags;
      const { flow_id } = this.state;
      const hideProctorModal = vetsmith_flow_ids_hide_acc_proctoring_modal.indexOf(flow_id) >= 0;
      if (maintenance_mcq_acc_apt) {
        openNotification(
          'info',
          'Maintenance',
          'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
          20
        );
        return;
      }

      const fastrackFlow = this.state.fastrack;
      let veRedirectParam = this.getVetsmithFlowRedirectUrl();
      localStorage.setItem('vetsmith_challenge_inprogress', 'true');
      if (+item.acc_challenge === 1) {
        localStorage.setItem('vetsmith_challenge_id', challenge_id);
        localStorage.setItem('take_acc_for_vetsmith', 1);
        localStorage.setItem('vetsmith_selected_flow', this.state.flow.flow_id);

        // Added !item.is_multiple_coding_challenge as multiple_coding_challenge does not set the coding language from admin panel and it is the vetting engine who decides the coding langauge
        if (!item.is_multiple_coding_challenge && this.state.steps && this.state.steps.coding_challenge && this.state.steps.coding_challenge.acc && parseInt(challenge_id) === parseInt(this.state.steps.coding_challenge.acc.challenge_id)) {
          localStorage.setItem('vetsmith_langs', this.state.steps.coding_challenge.step_coding_language);
        } else {
          localStorage.removeItem('vetsmith_langs');
        }  
        
        localStorage.setItem('vetsmith_selected_flow', this.state.flow.flow_id);

        if (!this.state.activeCodingChallengeItem && !hideProctorModal) {
          this.setShowAccWarningModalAndActiveCodingChallengeItem(true, item)
          return;  
        }
       
        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'ACC',
          action: 'VETSMITH_START_ACC',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_ACC_CTA`, {}, logBody);

        let urlToRedirect = PageConstant.ACC_CODING_PAGE;
          // This is where the redirect happens
        veRedirectParam = window.location.origin + veRedirectParam;
        return redirectVetsmithACCToVettingEngine(challenge_id, item.step_coding_language, veRedirectParam)
      } else {
        localStorage.setItem('vetsmith_challenge_active', item.active);
      }

      const logBody = {
        sessionId: this.state.sessionId,
        user,
        step: 'MCQ',
        action: 'VETSMITH_START_MCQ',
        challenge: item,
        flow_id: this.state.flow.flow_id
      };
      pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
        veRedirectParam = window.location.origin + veRedirectParam;
        if (use_vetting_engine_redirection) {
          return redirectToVettingEngineV2(challenge_id, true, veRedirectParam);
        } else {
          return redirectMCQToVettingEngine(challenge_id, true, veRedirectParam);
        }
    }

    /**
     * This function gets called when use_vetsmith_challenge_versioning is turned ON
     * This function gets called when use_vetsmith_mcq_challenge_versioning is turned ON
     */
    proceedMCQV2 = (challenge_main_id, item = null) => {
      const {
        maintenance_mcq_acc_apt = false,
        use_vetting_engine_redirection,
        vetsmith_flow_ids_hide_acc_proctoring_modal
      } = this.props.LDFlags;

      const { flow_id } = this.state;
      const hideProctorModal = vetsmith_flow_ids_hide_acc_proctoring_modal.indexOf(flow_id) >= 0;

      const challenge_id = item.challengeIdAttempted || challenge_main_id;

      if (maintenance_mcq_acc_apt) {
        openNotification(
          'info',
          'Maintenance',
          'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.',
          20
        );
        return;
      }

      const fastrackFlow = this.state.fastrack;
      let veRedirectParam = this.getVetsmithFlowRedirectUrl();
      // Move redirection declaration here as its duplicated in other conditions
      veRedirectParam = window.location.origin + veRedirectParam;
      localStorage.setItem('vetsmith_challenge_inprogress', 'true');
      if (+item.acc_challenge === 1) {
        localStorage.setItem('vetsmith_challenge_id', challenge_id);
        localStorage.setItem('take_acc_for_vetsmith', 1);
        localStorage.setItem('vetsmith_selected_flow', this.state.flow.flow_id);

        // Added !item.is_multiple_coding_challenge as multiple_coding_challenge does not set the coding language from admin panel and it is the vetting engine who decides the coding langauge
        if (!item.is_multiple_coding_challenge && this.state.steps && this.state.steps.coding_challenge && this.state.steps.coding_challenge.acc && parseInt(challenge_id) === parseInt(this.state.steps.coding_challenge.acc.id)) {
          localStorage.setItem('vetsmith_langs', this.state.steps.coding_challenge.step_coding_language);
        } else {
          localStorage.removeItem('vetsmith_langs');
        }  
        
        localStorage.setItem('vetsmith_selected_flow', this.state.flow.flow_id);

        if (!this.state.activeCodingChallengeItem && !hideProctorModal) {
          this.setShowAccWarningModalAndActiveCodingChallengeItem(true, item)
          return;  
        }

        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'ACC',
          action: 'VETSMITH_START_ACC',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_ACC_CTA`, {}, logBody);
        let urlToRedirect = PageConstant.ACC_CODING_PAGE;
          // This is where the redirect happens
          return redirectVetsmithACCToVettingEngine(challenge_id, item.step_coding_language, veRedirectParam)
      } else {
        localStorage.setItem('vetsmith_challenge_active', item.active);
      }

      if(item.is_twa) {
        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'TWA',
          action: 'VETSMITH_START_TWA',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
        if (use_vetting_engine_redirection) {
          return redirectToVettingEngineV2(challenge_id, true, veRedirectParam);
        } else {
          return redirectTWAToVettingEngine(challenge_id, true, veRedirectParam);
        }
      }

      if (item.is_rlhf) {
        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'RLHF',
          action: 'VETSMITH_START_RLHF',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_TWA_CTA`, {}, logBody);
        return redirectRLHFToVettingEngine(challenge_id, true, veRedirectParam);
      }

      if (item.is_ai) {
        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'AI',
          action: 'VETSMITH_START_AI',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_AI_CTA`, {}, logBody);
        return redirectAiToVettingEngine(challenge_id, true, veRedirectParam);
      }

      if (item.is_nte) {
        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'NTE',
          action: 'VETSMITH_START_NTE',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_NTE_CTA`, {}, logBody);
        return redirectToVettingEngine('/soft_skills', { challengeId: item.id ? item.id : null }, window.location.origin + '/enterprise?flow_id=' + this.state.flow.flow_id);
      }

        const logBody = {
          sessionId: this.state.sessionId,
          user,
          step: 'MCQ',
          action: 'VETSMITH_START_MCQ',
          challenge: item,
          flow_id: this.state.flow.flow_id
        };
        pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_MCQ_CTA`, {}, logBody);
        if (use_vetting_engine_redirection) {
          return redirectToVettingEngineV2(challenge_id, true, veRedirectParam);
        } else {
          return redirectMCQToVettingEngine(challenge_id, true, veRedirectParam);
        }
    }

    isAccInMultipleCodingChallenge = (challenge_id) => {
        let exist = false;
        const challengeIdsInMultipleCodingChallenge = this.state.steps.multiple_coding_challenge.acc.map(item => item.challenge_id);
        if (challengeIdsInMultipleCodingChallenge.includes(challenge_id)) {
          exist = true;
        }
        return exist;
    }

    /**
     * This function gets called when use_vetsmith_challenge_versioning or use_vetsmith_mcq_challenge_versioning is turned ON
     */
    isAccInMultipleCodingChallengeV2 = (challenge_id) => {
      let exist = false;
      const challengeIdsInMultipleCodingChallenge = this.state.steps.multiple_coding_challenge.acc.map(item => item.id);
      if (challengeIdsInMultipleCodingChallenge.includes(challenge_id)) {
        exist = true;
      }
      return exist;
  }

    bind = (name) => {
      const { createPasswordModal } = this.state;
      if (!createPasswordModal) return null;
      return {
        value: createPasswordModal[name] || '',
        onChange: (e) => {
          createPasswordModal[name] = e.target.value;
          this.setState({ createPasswordModal });
        }
      };
    }

    createPassword = (targetPage) => {
      if (this.state.flow && this.state.flow.new_signup && !this.state.flow.create_password) {
        pushLog2DV2LogServer.info(
          'VETSMITH FRONTEND',
          'VETSMITH_CREATE_PASSWORD',
          { user_id: user.uid },
          {
            user_id: user.uid,
            new_signup: this.state.flow.new_signup,
            flow_id: this.state.flow.flow_id,
            action: 'VETSMITH_NEW_SIGNUP_CREATE_PASSWORD'
          }, null);
        this.setState({ createPasswordModal: { password: '', confirmPassword: '', targetPage } });
      } else {
        this.goto(targetPage);
      }
    }

    createPasswordHandler = () => {
      const { createPasswordModal } = this.state;
      if (!createPasswordModal) return null;
      createPasswordModal.loading = true;
      this.setState({ createPasswordModal });
      addNewAccountSettings('password', createPasswordModal.password)
        .then(res => {
          if (res.data.success) {
            axios.post(`${ApiConstant.BASE_URL}vetsmith/password-created`, { flow_id: this.state.flow.flow_id })
              .catch(console.error)
              .finally(() => {
                pushLog2DV2LogServer.info(
                  'VETSMITH FRONTEND',
                  'VETSMITH_CREATE_PASSWORD',
                  { user_id: user.uid },
                  {
                    user_id: user.uid,
                    flow_id: this.state.flow.flow_id,
                    action: 'VETSMITH_NEW_SIGNUP_CREATE_PASSWORD_SUCCESS'
                  }, null);
                message.success('Your current password is updated!');
                this.goto(createPasswordModal.targetPage);
              });
          } else {
            message.error(res.data.message);
            pushLog2DV2LogServer.error(
              'VETSMITH FRONTEND',
              'VETSMITH_CREATE_PASSWORD',
              { user_id: user.uid },
              {
                user_id: user.uid,
                flow_id: this.state.flow.flow_id,
                action: 'VETSMITH_NEW_SIGNUP_CREATE_PASSWORD_ERROR'
              }, { message: res.data.message });
          }
        })
        .catch(error => {
          pushLog2DV2LogServer.error(
            'VETSMITH FRONTEND',
            'VETSMITH_CREATE_PASSWORD',
            { user_id: user.uid },
            {
              user_id: user.uid,
              flow_id: this.state.flow.flow_id,
              action: 'VETSMITH_NEW_SIGNUP_CREATE_PASSWORD_ERROR'
            }, { message: error.response.data.message });
          message.error(error.response.data.message);
        })
        .finally(() => {
          this.setState({ createPasswordModal: null });
        });
    }

    getJobStatus(status) {
      switch ((status || '').toLowerCase().trim()) {
        case 'pending ae review':
        case 'blessed by ae':
        case 'pending review':
        case 'blessed':
        case 'pending vetting':
          return 'Shortlisted';
        case 'included in packet':
        case 'pending onboarding':
        case 'sourced talent':
        case 'needs technical interview':
        case 'trial failed due to dev\'s fault':
        case 'obsolete':
        case 'engagement finished':
        case 'job lost or no customer response':
        case 'job paused':
        case 'candidate not interested':
        case 'candidate not reachable for interview':
        case 'selected for another job':
          return 'In Review';
        case 'scheduling client interview':
        case 'interview scheduled':
        case 'awaiting interview':
        case 'feedback':
        case 'selected for interview':
        case 'awaiting interview feedback':
        case 'awaiting client decision':
          return 'Interviewing';
        case 'selected for trial':
        case 'in trial':
        case 'trial passed':
          return 'Hired';
        case 'rejected by ae':
        case 'soft interview rejection':
        case 'hard interview rejection':
        case 'not selected from packet':
        case 'rejected':
        case 'rejected by vel':
        case 'rejected by vetting':
          return 'Not selected';
      }
      if (!status) return null;
      return 'In Review';
    }

    render() {
      const { loading, showSelectFlow, flows, activeItem, loadingItem, firstload, flow,
        createPasswordModal, aptId, warningAPTModalShow, accWarningModalShow, flow_id } = this.state;

      const { LDFlags, store } = this.props;

      const {
        use_vetsmith_challenge_versioning = false,
        use_vetsmith_mcq_challenge_versioning = false,
        vetsmith_flow_ids_hide_acc_proctoring_modal = []
      } = LDFlags;
      const hideProctorModal = vetsmith_flow_ids_hide_acc_proctoring_modal.indexOf(flow_id) >= 0;

      if (loading) return <Spin spinning={loading} />;
      if (showSelectFlow && !parentService) return <Welcome flows={flows} selectFlow={this.loadAndSelectFlow} />;
      if (!flow && !parentService) return <NoFlow goto={this.goto} />;

      return (
        <Spin spinning={loading}>
          <Component 
            store={this.props.store}
            history={this.props.history} 
            match={this.props.match} 
            infos={this.state} 
            service={this} 
            ldFlags={LDFlags}
          />

          {(use_vetsmith_mcq_challenge_versioning || (activeItem && activeItem.is_twa) || (activeItem && activeItem.is_rlhf) || (activeItem && activeItem.is_ai) || (activeItem && activeItem.is_nte)) ? (
              <StartMCQModalV2
              activeItem={activeItem}
              loading={loadingItem || loading}
              testsService={this}
              />
          ) : (
            <StartMCQModal
              activeItem={activeItem}
              loading={loadingItem || loading}
              testsService={this}
            />
          )}

          <FailedMCQModal
              visible={this.state.showFailedModal.visible}
              item={this.state.showFailedModal.item}
              onCancel={() => this.setShowFailedModal(false)}
              editSkills={this.editSkills}
              test={this.state.showFailedModal.test}
          />

          {!hideProctorModal && accWarningModalShow && !use_vetsmith_challenge_versioning ? (
            <CodingChallengeWarning
              onStart={() =>
                    this.proceedMCQ(this.state.activeCodingChallengeItem.challenge_id, this.state.activeCodingChallengeItem)
              }
              onCancel={() => this.setShowAccWarningModalAndActiveCodingChallengeItem(false,  null)}
              isInProgress={this.state.activeCodingChallengeItem.passed !== 1 && this.state.activeCodingChallengeItem.timeLeft > 0}
              user={user}
              codingChallengeId={this.state.activeCodingChallengeItem ? this.state.activeCodingChallengeItem.challenge_id : null}
              isVetsmithACC={true}
            />
          ) : null}

          {!hideProctorModal && accWarningModalShow && use_vetsmith_challenge_versioning ? (
            <CodingChallengeWarning
              onStart={() =>
                    this.proceedMCQV2(this.state.activeCodingChallengeItem.id, this.state.activeCodingChallengeItem)
              }
              onCancel={() => this.setShowAccWarningModalAndActiveCodingChallengeItem(false,  null)}
              isInProgress={this.state.activeCodingChallengeItem.state === TestState.IN_PROGRESS}
              user={user}
              codingChallengeId={this.state.activeCodingChallengeItem ? this.state.activeCodingChallengeItem.id : null}
              isVetsmithACC={true}
            />
          ) : null}

          <UploadResumeModal
            {...this.state.uploadResumeProps}
            onCancel={this.handleUploadResumeClick}
            onOk={this.saveUploadResume}
            profileService={this}
            loading={loadingItem || loading}
          />
          <Modal
            title="Create a password"
            visible={!!createPasswordModal}
            width={396}
            className="password-modal"
            okText="Create password"
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ disabled: createPasswordModal && (!createPasswordModal.password || createPasswordModal.password !== createPasswordModal.confirmPassword || `${createPasswordModal.password}`.length < 8) }}
            onOk={this.createPasswordHandler}
            onCancel={() => this.setState({ createPasswordModal: null })}
            confirmLoading={createPasswordModal && createPasswordModal.loading}
          >
            <div className='create-password-modal'>
              <p>To use the Talent Portal, please create a password that you will use to access your account.</p>
              <Input.Password label="Create a password" help="Use 8 or more characters" required placeholder="Password" {...this.bind('password')} />
              <Input.Password label="Confirm password" help="Password must match previous field" required placeholder="Password" {...this.bind('confirmPassword')} />
            </div>
          </Modal>
        </Spin>
      );
    }
  }

  const mapStateToProps = (store) => ({ store });
  const mapDispatchToProps = (dispatch) => ({ dispatch });

  VetsmithService.propTypes = {
    store: PropTypes.object,
    history: PropTypes.any,
    location: PropTypes.any,
    dispatch: PropTypes.func
  };

  return connect(mapStateToProps, mapDispatchToProps)(withRouter(
    withLDFlagsFromBackend(VetsmithService,
      [GB_FLAGS.show_apt_plagiarism_warning,
      GB_FLAGS.gb_apt_instructions_config,
      GB_FLAGS.show_apt_requirements_warning,
      GB_FLAGS.use_vetting_engine_acc,
      GB_FLAGS.maintenance_mcq_acc_apt,
      GB_FLAGS.use_vetting_engine_redirection,
      GB_FLAGS.use_vetsmith_challenge_versioning,
      GB_FLAGS.use_vetsmith_mcq_challenge_versioning,
      GB_FLAGS.vetsmith_flow_ids_hide_acc_proctoring_modal,
      GB_FLAGS.job_dashboard_v2
      ]
    )
  ));
}

const gtmTag = (event, mcq) => {
  /* NEW GTM REQUEST */

  const currentQuery = queryString.parse(window.location.search);
  const s_param = currentQuery.s || '';

  const tagManagerArgs = {
    gtmId: getEnv("REACT_APP_GTM_ID"),
    dataLayer: {
      event,
      userEmail: localStorage.getItem('userEmail'),
      s_param,
      tookMCQ: {
        mcq_id: mcq.challenge_id,
        mcq_name: mcq.challenge_name
      }
    }
  };

  TagManager.dataLayer(tagManagerArgs);
};

export function getVetsmithACCID() {
  if (localStorage.getItem('take_acc_for_vetsmith') && localStorage.getItem('vetsmith_challenge_id') && parseInt(localStorage.getItem('vetsmith_challenge_id'))) {
    return parseInt(localStorage.getItem('vetsmith_challenge_id'));
  }
  return null;
}

export default withVetsmithService;
